import { render, staticRenderFns } from "./OpportunitiesDueTodayByOwnerChart.vue?vue&type=template&id=40dd70f8"
import script from "./OpportunitiesDueTodayByOwnerChart.vue?vue&type=script&lang=js"
export * from "./OpportunitiesDueTodayByOwnerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports